module.exports = __webpack_public_path__ + "static/media/defaultComic.55d89836.jpg";